import { Grid } from "@mui/system";
import { Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import MonthlyEarningGapsTable, {
  MONTHLY_EARNING_GAPS_COLUMNS,
} from "./MonthlyEarningGapsTable";
import { exportRowsToCsv } from "../Utils/anomaliesColumns";
import BrandSearchBar from "../Utils/BrandSearchBar";

const MonthlyEarningGaps = () => {
  const [choosenBrand, setChosenBrand] = useState<string | null>(null);

  const monthlyEarningGapsData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.monthlyEarningGapsData,
  );

  const monthlyEarningGapsMetadata = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.monthlyEarningGapsMetadata,
  );

  const isFetchedForEarningData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.isFetchedForEarningData,
  );

  //-- Extract unique brand names for the search filter
  const brandNames = useMemo(() => {
    const set = new Set<string>();
    (monthlyEarningGapsData || []).forEach((r: any) => {
      if (typeof r?.brand_name === "string") set.add(r.brand_name.trim());
    });
    return Array.from(set);
  }, [monthlyEarningGapsData]);

  // filter rows by the chosen brand
  const filteredData = useMemo(() => {
    const search = (choosenBrand ?? "").trim().toLowerCase();
    if (!search) return monthlyEarningGapsData;
    return (monthlyEarningGapsData || []).filter((row: any) =>
      String(row.brand_name ?? "")
        .toLowerCase()
        .includes(search),
    );
  }, [monthlyEarningGapsData, choosenBrand]);

  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="center"
        px={2}
        py={1.5}
        sx={{ borderTop: "1px solid #0000001F" }}
      >
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            Monthly Earning Gaps in MTD
          </Typography>
        </Grid>
        <Grid size={4}>
          <BrandSearchBar
            dataTrackerForSearch="890"
            brandNames={brandNames}
            chosenBrand={choosenBrand}
            onBrandChange={setChosenBrand}
            dataTrackerForDownload="888"
            onDownload={() =>
              exportRowsToCsv(
                filteredData,
                MONTHLY_EARNING_GAPS_COLUMNS,
                "monthly-earning-gaps-mtd.csv",
              )
            }
            disabled={
              (monthlyEarningGapsData?.length ?? 0) === 0 ||
              !isFetchedForEarningData
            }
          />
        </Grid>
      </Grid>
      <MonthlyEarningGapsTable
        metadata={monthlyEarningGapsMetadata}
        rows={filteredData}
      />
    </>
  );
};

export default MonthlyEarningGaps;
